export default __webpack_public_path__ + "static/media/calender.f7631dc9.svg";